// The single mutable application store. Mutated in place by views and loaders.
import { inviteFromURL } from "./config.js";
import { parentSelectedChild } from "./views/parent.js";

export const state = {
  session: null,
  account: null,
  roles: [],
  profiles: [],
  profile: null,
  exercises: [],
  view: "home",
  language: localStorage.getItem("brainmath-language") || (navigator.language.startsWith("it") ? "it" : "en"),
  verificationEmail: sessionStorage.getItem("brainmath-verification-email"),
  betaInviteToken: localStorage.getItem("brainmath-beta-invite") || inviteFromURL || "",
  betaInviteDetails: null,
  turnstileToken: "",
  exerciseSession: null,
  exerciseTimer: null,
  pendingProfileToken: location.pathname.startsWith("/profile/")
    ? location.pathname.split("/").filter(Boolean).pop()
    : null,
  pendingClassToken: location.pathname.startsWith("/class/")
    ? location.pathname.split("/").filter(Boolean).pop()
    : null,
  teacherMode: false,
  parentMode: false,
  adminMode: false,
  isAdmin: false,
  adminSummary: null,
  adminDashboard: null,
  adminUsage: [],
  adminDailyUsage: [],
  adminHourlyConnections: [],
  adminUsers: [],
  adminBetaRequests: [],
  adminBetaRefreshedAt: null,
  adminPlatformCosts: [],
  adminTokenReviews: [],
  adminSupabaseUsage: null,
  adminExercises: [],
  adminTab: "dashboard",
  parentTab: "today",
  parentOverview: [],
  parentActivity: [],
  parentResults: [],
  parentSelectedChild: null,
  catalogGradeRanges: {},
  classes: [],
  schoolClasses: [],
  academicYears: [],
  enrollments: [],
  teacherStudents: [],
  teacherSchools: [],
  teacherExercises: [],
  teacherCatalogExercises: [],
  teacherOrgTab: "schools",
  learningHierarchy: [],
  catalogNavigation: {
    teacher: { schoolLevel: null, grade: null, macro: null, learningTopic: null, difficulty: null },
    admin: { schoolLevel: null, grade: null, macro: null, learningTopic: null, difficulty: null }
  },
  aiWallet: null,
  creditProducts: [],
  busy: false
};
